export function mapTourV2Facets(tourFacets?: App.TourSearchFacets) {
  if (tourFacets?.price === undefined || tourFacets?.price === null) {
    return tourFacets
  }

  const step = tourFacets.price.max <= 10000 ? 10 : 100

  return {
    ...tourFacets,
    price: {
      ...tourFacets.price,
      max: Math.ceil(tourFacets.price.max / step) * step,
    },
  }
}
